export default {
  alignment: 'Ausrichtung',
};
